export enum PriceRange {
    Low, Medium, High, Expensive
}